import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_zonahoraria_id: new EntityColumn<string>({ name: 'c_zonahoraria_id', type: 'char', length: 20, flags: c.PK, prompt: 'Zona Horaria Id' }),
        vc_zonahoraria_nombre: new EntityColumn<string>({ name: 'vc_zonahoraria_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        zoho_brwStandard: { name: 'zoho_brwStandard', keyMappings: { c_zonahoraria_id: 0 } }
    }
)


export class ZonasHorariasDef extends EntityDefinition {

    columns = columns();
    views = views();


    constructor() {
        super('ZonasHorarias');
    }
}